import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdClose,
  MdDelete,
  MdEdit,
  MdMail,
  MdPeopleOutline,
  MdPhone,
  MdSend,
  MdVisibility,
  MdLocationOn,
  MdBusiness,
  MdGroup,
  MdAssignment,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { ExclamationCircleFilled } from "@ant-design/icons";
import api from "../../../services/api";
import {
  ViewInput,
  Message,
  InputTel,
  HeaderTitle,
} from "../../../GlobalStyles";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Input,
  Pagination,
  Select,
  DatePicker,
  Spin,
  Space,
  Tooltip,
} from "antd";
import { FaWhatsapp } from "react-icons/fa";
import IntlCurrencyInput from "react-intl-currency-input";
import { addDays, format } from "date-fns";
import { Container, Card, Label, AssociateInfo, InfoTag } from "./styles";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import userPhoto from "../../../images/user.png";
import { getValue } from "../../../services/functions";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

dayjs.extend(weekday);
dayjs.extend(localeData);

const { confirm } = Modal;

const Leads = () => {
  const navigate = useNavigate();

  const [leads, setLeads] = useState([]);
  const [leadsToSend, setLeadsToSend] = useState([]);
  const [userSend, setUserSend] = useState("");
  const [leadsSend, setLeadsSend] = useState([]);
  const [franqueadosAll, setFranqueadosAll] = useState([]);
  const [franqueadosLead, setFranqueadosLead] = useState([]);
  const [associadosAll, setAssociadosAll] = useState([]);
  const [associate_id, setAssociate_id] = useState("");
  const [lead, setLead] = useState({});
  const [leadsTotal, setLeadsTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [value, setValue] = useState(0);
  const [price, setPrice] = useState(0);
  const [page, setPage] = useState(0);
  const [id, setId] = useState("");
  const [dateStart, setDateStart] = useState(addDays(new Date(), -30));
  const [dateEnd, setDateEnd] = useState(new Date());
  const [multiLeads, setMultiLeads] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLead, setIsOpenLead] = useState(false);
  const [isOpenSend, setIsOpenSend] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [observation, setObservation] = useState("");
  const [employees, setEmployees] = useState("");
  const [necessity, setNecessity] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [tag, setTag] = useState("");
  const [all, setAll] = useState(true);
  const [location, setLocation] = useState("");

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  useEffect(() => {
    loadLeads(page, all, tag, dateStart, dateEnd);
  }, [page, all, tag, dateStart, dateEnd]);

  useEffect(() => {
    loadLeadsAll();
    loadFranqueados();
    loadAssociados();
  }, []);

  async function loadAssociados() {
    await api
      .get(`/associates?all=true`)
      .then((response) => {
        setAssociadosAll(response.data.associates);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadFranqueados() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setFranqueadosAll(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadLeads(page, all, tag, dateStart, dateEnd) {
    await api
      .get(
        `/leads-send?page=${page}&tag=${tag}${
          !all ? `&dateStart=${dateStart}&dateEnd=${dateEnd}` : ""
        }`,
      )
      .then((response) => {
        setLeads(response.data.leads);
        setLeadsTotal(response.data.leadsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function loadLeadsAll() {
    await api
      .get(`/leads-send?all=true`)
      .then((response) => {
        setLeadsToSend(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function createLead() {
    if (!name) {
      toast.warn("Preencha o nome para salvar lead");
    } else {
      if (email) {
        if (!IsEmail(email)) {
          toast.warn("Email inserido é inválido");
          return;
        }
      }
      if (phone_number) {
        if (!IsPhone(phone_number)) {
          toast.warn("Telefone inserido é inválido");
          return;
        }
      }
      if (id) {
        await api
          .put(`/lead/master/${id}`, {
            name: name,
            value: value,
            email: email,
            observation: observation,
            phone_number: phone_number,
            employees: employees,
            necessity: necessity,
            cnpj: cnpj,
            location: location,
            price: price,
            associate_id: associate_id,
          })
          .then((response) => {
            toast.success("Lead editado com sucesso");
            loadLeads(page, all, tag, dateStart, dateEnd);
            setIsOpen(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      } else {
        await api
          .post(`/lead/master`, {
            name: name,
            value: value,
            email: email,
            observation: observation,
            phone_number: phone_number,
            employees: employees,
            necessity: necessity,
            cnpj: cnpj,
            location: location,
            price: price,
            associate_id: associate_id,
          })
          .then((response) => {
            toast.success("Lead criado com sucesso");
            loadLeads(page, all, tag, dateStart, dateEnd);
            setIsOpen(false);
            loadLeadsAll();
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
  }

  async function sendLead() {
    if (!leads.length || !userSend) {
      toast.warn(
        leadsSend.length > 1
          ? "Selecione o franqueado e os leads para enviar"
          : "Selecione o franqueado e o lead para enviar",
      );
    } else {
      await api
        .put(`/lead/send`, {
          leads: multiLeads ? leadsSend : [id],
          userId: userSend,
        })
        .then((response) => {
          toast.success(
            `Lead${leadsSend.length > 1 && "s"} enviado com sucesso`,
          );
          loadLeads(page, all, tag, dateStart, dateEnd);
          setIsOpenSend(false);
          loadLeadsAll();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
  }

  async function deleteLead(lead) {
    await api
      .delete(`/lead/master/${lead.id}`)
      .then((response) => {
        toast.success("Lead deletado com sucesso");
        loadLeads(page, all, tag, dateStart, dateEnd);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  function IsEmail(field) {
    const regx = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i;
    return regx.test(field);
  }

  function IsPhone(field) {
    if (field.length >= 10) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Container>
      <HeaderTitle>
        <h1 style={{ flex: 1 }}>Leads Abertos</h1>
        {!isLoading && (
          <Space>
            <Button
              type="primary"
              style={{ borderRadius: 50 }}
              onClick={() => {
                setLeadsSend([]);
                setUserSend(null);
                setMultiLeads(true);
                setIsOpenSend(true);
              }}
            >
              <MdAdd size="20" color="#fff" />
              <span>Enviar Leads</span>
            </Button>
            <Button
              type="primary"
              style={{
                borderRadius: 50,
              }}
              onClick={() => {
                setName("");
                setEmail("");
                setObservation("");
                setEmployees("");
                setCnpj("");
                setNecessity("");
                setLocation("");
                setValue(0);
                setPrice(0);
                setPhone_number("");
                setId("");
                setAssociate_id(null);
                setIsOpen(true);
              }}
            >
              <MdAdd size="20" color="#fff" />
              <span>Novo Lead</span>
            </Button>
          </Space>
        )}
      </HeaderTitle>

      {isLoading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={leadsTotal} separator="." />
          </Card>
          <div className="filters-row">
            <ViewInput style={{ width: "100%", maxWidth: 220 }}>
              <p>Visualizar</p>
              <div style={{ display: "flex", gap: 10 }}>
                <Button
                  style={{
                    backgroundColor: all ? "#008037" : "#FFF",
                    color: all ? "#FFF" : "#008037",
                    flex: 1,
                    borderColor: "#008037",
                    borderRadius: 50,
                  }}
                  onClick={() => {
                    setAll(true);
                  }}
                >
                  Todos
                </Button>
                <Button
                  style={{
                    backgroundColor: !all ? "#008037" : "#FFF",
                    color: !all ? "#FFF" : "#008037",
                    flex: 1,
                    borderColor: "#008037",
                    borderRadius: 50,
                  }}
                  onClick={() => {
                    setAll(false);
                  }}
                >
                  Período
                </Button>
              </div>
            </ViewInput>
            {!all && (
              <ViewInput style={{ width: "100%", maxWidth: 280 }}>
                <p>Filtrar por Período de Cadastro</p>
                <RangePicker
                  style={{ width: "100%" }}
                  placeholder={["inicial", "final"]}
                  value={[
                    dateStart ? dayjs(dateStart) : "",
                    dateEnd ? dayjs(dateEnd) : "",
                  ]}
                  format={"DD/MM/YYYY"}
                  onChange={(value, dateString) => {
                    if (value) {
                      setDateStart(value[0].toDate());
                      setDateEnd(value[1].toDate());
                    }
                    setPage(0);
                  }}
                  allowClear={false}
                />
              </ViewInput>
            )}

            <ViewInput style={{ width: 180 }}>
              <p>Filtrar por Tag</p>
              <Select
                placeholder="selecionar tag"
                value={tag || null}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setTag(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todas as Tags</Select.Option>
                {["ROI", "API", "Associado", "Cadastrado"].map((item) => {
                  return (
                    <Select.Option key={item} value={item}>
                      {item}
                    </Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
          </div>
          {leads?.length ? (
            <div className="leads-list">
              {leads.map((lead) => (
                <div className="lead-card" key={lead.id}>
                  <div className="main-info">
                    <Tooltip title={lead.name}>
                      <strong>{lead.name}</strong>
                    </Tooltip>
                    <div className="tag-badge">{lead.tag}</div>
                  </div>

                  <div className="info-item">
                    <label>E-mail</label>
                    <Tooltip title={lead.email || "Sem e-mail"}>
                      <span
                        style={{
                          maxWidth: 150,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {lead.email || "Sem e-mail"}
                      </span>
                    </Tooltip>
                  </div>

                  <div className="info-item">
                    <label>Telefone</label>
                    <span>
                      {lead.phone_number.replace(
                        /(\d{2})(\d{5})(\d{4})/,
                        "($1) $2-$3",
                      ) || "Sem telefone"}
                    </span>
                  </div>

                  <div className="info-item">
                    <label>Cadastro</label>
                    <span>
                      {format(new Date(lead.create_at), "dd/MM/yyyy HH:mm")}
                    </span>
                  </div>

                  <div className="info-item">
                    <label>Valor Lead</label>
                    <span style={{ color: "#008037", fontWeight: "bold" }}>
                      {(lead.value || 0).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </span>
                  </div>

                  <div className="actions">
                    <Tooltip title="Ver Detalhes">
                      <Button
                        shape="circle"
                        icon={<MdVisibility size={18} />}
                        onClick={() => {
                          setLead(lead);
                          setIsOpenLead(true);
                        }}
                      />
                    </Tooltip>
                    {!lead.is_user && !lead.leads.length && (
                      <Tooltip title="Enviar Lead">
                        <Button
                          shape="circle"
                          icon={<MdSend size={16} />}
                          onClick={() => {
                            setUserSend(null);
                            setId(lead.id);
                            setMultiLeads(false);
                            setFranqueadosLead(lead.leads);
                            setLeadsSend([]);
                            setIsOpenSend(true);
                          }}
                        />
                      </Tooltip>
                    )}
                    <Tooltip title="Editar">
                      <Button
                        shape="circle"
                        icon={<MdEdit size={18} />}
                        onClick={() => {
                          setId(lead.id);
                          setName(lead.name);
                          setEmail(lead.email);
                          setPhone_number(lead.phone_number);
                          setNecessity(lead.necessity);
                          setLocation(lead.location);
                          setEmployees(lead.employees);
                          setValue(lead.value);
                          setPrice(lead.price);
                          setCnpj(lead.cnpj);
                          setAssociate_id(lead.associate_id);
                          setObservation(lead.observation);
                          setIsOpen(true);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <Button
                        shape="circle"
                        danger
                        icon={<MdDelete size={18} />}
                        onClick={() => {
                          confirm({
                            okText: "Confirmar",
                            title: "Deseja excluir o Lead?",
                            icon: <ExclamationCircleFilled />,
                            content: `Após essa ação, o Lead ${lead.name} e todos leads duplicados também serão excluidos.`,
                            onOk() {
                              deleteLead(lead);
                            },
                            onCancel() {},
                            cancelText: "Cancelar",
                          });
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              ))}

              <Pagination
                style={{
                  margin: "25px 0",
                  alignSelf: "center",
                }}
                defaultCurrent={page + 1}
                onChange={(page) => {
                  setPage(page - 1);
                }}
                total={leadsTotal}
                pageSize={30}
                showTotal={(total) => `${total} leads`}
              />
            </div>
          ) : (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
                border: "1px solid #eee",
              }}
            >
              <MdPeopleOutline
                size={50}
                color="#ccc"
                style={{ marginBottom: 15 }}
              />
              <Message>Nenhum lead encontrado.</Message>
            </div>
          )}
        </>
      )}

      <Modal
        title={id ? "Editando lead" : "Cadastrando um novo lead"}
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "Editar" : "Cadastrar"}
        cancelText="Cancelar"
        onOk={() => {
          createLead();
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <ViewInput>
            <p>Nome*</p>
            <Input
              placeholder="nome"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Email*</p>
            <Input
              placeholder="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </ViewInput>
          <ViewInput className="input">
            <p>Telefone</p>
            <InputTel
              mask="(99) 99999-9999"
              maskChar=""
              noSpaceBetweenChars={true}
              value={phone_number}
              placeholder={"telefone"}
              style={{}}
              onChange={(text) => {
                setPhone_number(text.target.value.replace(/[^0-9]/g, ""));
              }}
            />
          </ViewInput>
          <ViewInput>
            <p>Necessidade</p>
            <Input
              placeholder="necessidade"
              value={necessity}
              onChange={(event) => setNecessity(event.target.value)}
            />
          </ViewInput>
          <ViewInput
            style={{
              width: "48%",
            }}
          >
            <p>Funcionários</p>
            <Input
              placeholder="funcionários"
              value={employees}
              onChange={(event) => setEmployees(event.target.value)}
            />
          </ViewInput>
          <ViewInput
            style={{
              width: "48%",
            }}
          >
            <p>Localização</p>
            <Input
              placeholder="localização"
              value={location}
              onChange={(event) => setLocation(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>CNPJ</p>
            <Input
              placeholder="cnpj"
              value={cnpj}
              onChange={(event) => setCnpj(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Observação</p>
            <TextArea
              style={{ minHeight: 60 }}
              placeholder="observação"
              value={observation}
              onChange={(event) => setObservation(event.target.value)}
            />
          </ViewInput>
          <ViewInput
            style={{
              width: "48%",
            }}
          >
            <p>Valor</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={value}
              onChange={(event, value) => setValue(value)}
            />
          </ViewInput>
          <ViewInput
            style={{
              width: "48%",
            }}
          >
            <p>Preço de Venda</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={price}
              onChange={(event, value) => setPrice(value)}
            />
          </ViewInput>
          <ViewInput style={{ width: "100%", marginTop: 5 }}>
            <p>Selecionar Associado</p>
            <Select
              placeholder="selecionar associado"
              value={associate_id || null}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%", textAlign: "left" }}
              onChange={(value) => {
                setAssociate_id(value);
              }}
            >
              {associadosAll.map((item) => {
                return (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                );
              })}
            </Select>
          </ViewInput>
        </div>
      </Modal>

      <Modal
        title="Enviar Leads"
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpenSend}
        okText={"Enviar"}
        cancelText="Cancelar"
        onOk={() => {
          sendLead();
        }}
        onCancel={() => {
          setIsOpenSend(false);
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginBottom: 25,
          }}
        >
          <ViewInput>
            <p>Selecione o Franqueado*</p>

            <Select
              placeholder="selecionar franqueado"
              value={userSend}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%", textAlign: "left" }}
              onChange={(value) => {
                setUserSend(value);
              }}
            >
              {franqueadosAll
                .filter(
                  (item) =>
                    !franqueadosLead.some((data) => item.id === data.user_id),
                )
                .map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
            </Select>
          </ViewInput>
          {multiLeads && (
            <ViewInput>
              <p>Selecione os Leads*</p>
              <Select
                placeholder="selecionar franqueado"
                value={leadsSend}
                mode="multiple"
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setLeadsSend(value);
                }}
              >
                {leadsToSend.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
          )}
        </div>
      </Modal>
      <Modal
        width={500}
        open={isOpenLead}
        onCancel={() => setIsOpenLead(false)}
        footer={null}
        closable={false}
        styles={{ content: { padding: 0 } }}
      >
        <div
          style={{
            position: "relative",
            background: "#fff",
            borderRadius: 5,
            padding: "25px 20px 20px 20px",
            borderTop: "30px solid #d7f0db",
          }}
        >
          <MdClose
            style={{
              position: "absolute",
              cursor: "pointer",
              top: -25,
              right: 10,
            }}
            size={20}
            color="#333"
            onClick={() => setIsOpenLead(false)}
          />
          <header
            style={{
              position: "absolute",
              top: -22,
              left: 15,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Label color={"#008037"} />
            <p
              style={{
                marginLeft: 5,
                fontSize: 12,
                fontWeight: 500,
                color: "#000a",
              }}
            >
              Detalhes do Lead
            </p>
          </header>

          <h2 style={{ marginTop: 10, fontSize: 22 }}>{lead.name}</h2>

          <InfoTag>
            {lead.email && (
              <div className="tag">
                <MdMail size={14} /> {lead.email}
              </div>
            )}
            {lead.phone_number && (
              <div className="tag">
                <MdPhone size={14} /> {lead.phone_number}
              </div>
            )}
            {lead.location && (
              <div className="tag">
                <MdLocationOn size={14} /> {lead.location}
              </div>
            )}
            {lead.cnpj && (
              <div className="tag">
                <MdBusiness size={14} /> CNPJ: {lead.cnpj}
              </div>
            )}
            {lead.employees && (
              <div className="tag">
                <MdGroup size={14} /> {lead.employees} func.
              </div>
            )}
            {lead.necessity && (
              <div className="tag">
                <MdAssignment size={14} /> {lead.necessity}
              </div>
            )}
          </InfoTag>

          <div style={{ margin: "15px 0" }}>
            <p style={{ fontSize: 13, color: "#666", marginBottom: 5 }}>
              Observações do Cadastro:
            </p>
            <p style={{ fontSize: 14, fontWeight: "normal", color: "#333" }}>
              {lead.observation || "Sem observações adicionais."}
            </p>
          </div>

          <div
            style={{
              background: "#f9f9f9",
              padding: 15,
              borderRadius: 10,
              margin: "15px 0",
            }}
          >
            <p style={{ fontSize: 12, color: "#888", margin: 0 }}>
              Valor Estimado:
            </p>
            <p
              style={{
                fontSize: 20,
                color: "#008037",
                fontWeight: "bold",
                margin: 0,
              }}
            >
              {getValue(lead.value || 0)}
            </p>
          </div>

          <div style={{ display: "flex", gap: 15, marginTop: 10 }}>
            {lead.phone_number && (
              <FaWhatsapp
                size={22}
                color="#25D366"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    `https://api.whatsapp.com/send/?phone=55${lead.phone_number}`,
                  )
                }
              />
            )}
            {lead.phone_number && (
              <MdPhone
                size={22}
                color="#333"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`tel:${lead.phone_number}`)}
              />
            )}
            {lead.email && (
              <MdMail
                size={22}
                color="#EA4335"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(`mailto:${lead.email}`)}
              />
            )}
          </div>

          {!!lead.leads?.length && (
            <div style={{ marginTop: 20 }}>
              <p style={{ margin: "10px 0", fontSize: 13, fontWeight: "bold" }}>
                Histórico de Envio ({lead.leads?.length}):
              </p>
              <div style={{ maxHeight: 150, overflowY: "auto", padding: 5 }}>
                {lead.leads?.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      borderBottom:
                        index + 1 !== lead.leads?.length
                          ? "1px solid #eee"
                          : "none",
                      padding: "8px 0",
                    }}
                  >
                    <p
                      style={{
                        fontSize: 13,
                        color: "#333",
                        margin: 0,
                        fontWeight: 600,
                      }}
                    >
                      {item.user?.name}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 4,
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          color: "#008037",
                          fontWeight: 700,
                        }}
                      >
                        {item.status || "Pendente"}
                      </span>
                      <span style={{ fontSize: 11, color: "#999" }}>
                        {format(new Date(item.create_at), "dd/MM/yyyy HH:mm")}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {(lead.associate || lead.associate_id) && (
            <AssociateInfo>
              <img
                src={
                  lead.associate?.photo ||
                  associadosAll.find((a) => a.id === lead.associate_id)?.photo
                    ? lead.associate?.photo_url ||
                      associadosAll.find((a) => a.id === lead.associate_id)
                        ?.photo_url
                    : userPhoto
                }
                alt="Perfil"
              />
              <div className="info">
                <span>Indicado por:</span>
                <strong>
                  {lead.associate?.name ||
                    associadosAll.find((a) => a.id === lead.associate_id)?.name}
                </strong>
              </div>
            </AssociateInfo>
          )}
        </div>
      </Modal>
    </Container>
  );
};

export default Leads;
